export class TextSizePerformBegin {
    parent;
    textSizeBeforePerform = 12;
    constructor(parent) {
        this.parent = parent;
    }
    get performer() {
        return this.parent;
    }
    prepareSizing() {
        // if (!this.performer.group.globalTextsizer.isMasterSizer) return false;
        this.cacheDOMItems();
        const noChildsToResize = this.performer.groupItems.cachedGroupItems.length === 0;
        if (noChildsToResize)
            return true;
        const noBorders = this.performer.borders.allCachedBorderDomElements.length === 0;
        if (noBorders)
            return true; // abort
        const foundManualSize = this.performer.groupItems.cachedGroupItems.find(el => el.getAttribute('data-fontsizemanual') === '1');
        if (foundManualSize)
            return true; // abort
        this.saveTextSizeBeforePerform();
        return false;
    }
    cacheDOMItems() {
        this.performer.groupItems.cachedGroupItems = this.performer.groupItems.childs;
        this.performer.borders.cacheAllBorders();
    }
    saveTextSizeBeforePerform() {
        this.textSizeBeforePerform = this.performer.groupItems.currentScaledFontSize;
    }
}
